module.exports = __webpack_public_path__ + "archivist_sperperare.gif?7d1aa11845e628ff5baf38387ec41837";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_sperperare.gif
// module id = 371
// module chunks = 0